import React from 'react';
import './home.scss';
import EnjoyTv from "../../components/EnjoyTV/enjoyTV";
import MorePlace from "../../components/MorePlaces/morePlace";

const Home = () => {
    return (
        <div id="home">
            <div className="container">
                <div className="home">

                </div>
            </div>
        </div>
    );
};

export default Home;